import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ModalSelectDocumentsComponent } from '../modal-select-documents/modal-select-documents.component';

interface GeneratedStatement {
  statement: string;
  comment: string;
  loe: string;
  gor: string;
  ref: string;
}

interface FakeDocument {
  id: string;
  name: string;
  type: string;
  uploadDate: Date;
}

@Component({
  selector: 'app-statement-generator',
  templateUrl: './statement-generator.component.html',
  styleUrls: ['./statement-generator.component.scss']
})
export class StatementGeneratorComponent implements OnInit {

  selectedDocuments: FakeDocument[] = [];
  generatedStatements: GeneratedStatement[] = [];
  isGenerating = false;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openDocumentSelector(): void {
    const dialogRef = this.dialog.open(ModalSelectDocumentsComponent, {
      width: '800px',
      data: {
        title: 'modals.select-documents.title',
        selectedDocuments: this.selectedDocuments
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.selectedDocuments) {
        this.selectedDocuments = result.selectedDocuments;
      }
    });
  }

  generateStatements(): void {
    if (this.selectedDocuments.length === 0) {
      return;
    }

    this.isGenerating = true;

    // Simulate API call delay
    setTimeout(() => {
      this.generatedStatements = this.createFakeStatements();
      this.isGenerating = false;
    }, 2000);
  }

  private createFakeStatements(): GeneratedStatement[] {
    const fakeStatements: GeneratedStatement[] = [
      {
        statement: 'SBRT può tardare il cambio terapia sistemica in mTNBC',
        comment: 'Evidenza da studi osservazionali suggerisce beneficio su TTNT',
        loe: '2b',
        gor: 'B',
        ref: 'https://pubmed.ncbi.nlm.nih.gov/34567890'
      },
      {
        statement: 'La radioterapia stereotassica migliora il controllo locale nel carcinoma mammario',
        comment: 'Studi randomizzati controllati dimostrano efficacia superiore',
        loe: '1b',
        gor: 'A',
        ref: 'https://pubmed.ncbi.nlm.nih.gov/34123456'
      },
      {
        statement: 'Il trattamento combinato riduce la progressione di malattia',
        comment: 'Meta-analisi di studi prospettici conferma i benefici',
        loe: '1a',
        gor: 'A',
        ref: 'https://pubmed.ncbi.nlm.nih.gov/34789012'
      }
    ];

    // Return a subset based on selected documents
    return fakeStatements.slice(0, Math.min(this.selectedDocuments.length, fakeStatements.length));
  }

  removeDocument(index: number): void {
    this.selectedDocuments.splice(index, 1);
    this.generatedStatements = [];
  }

  clearAll(): void {
    this.selectedDocuments = [];
    this.generatedStatements = [];
  }
}
